import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../context/I18nContext';
import { publicApi } from '../api';
import { useApi } from '../hooks/useApi';
import { staticImg } from '../utils/media';
import { Gift, ArrowRight, Download } from 'lucide-react';

export default function FreeSystems() {
  const { lang, tr } = useI18n();
  const { data } = useApi(() => publicApi.freeProducts(lang), [lang]);
  const list = (data || []).slice(0, 3);
  if (!list.length) return null;

  return (
    <section className="relative py-16 md:py-24 lg:py-28 bg-[#0a0a0e]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-12">
          <div>
            <div className="flex items-center gap-2 text-xs font-bold tracking-[0.3em] text-[#e4b44e]/85 mb-3">
              <Gift className="w-3.5 h-3.5" /> {tr('home.free_systems', 'ÜCRETSİZ SİSTEMLER')}
            </div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-black text-white leading-tight">
              {tr('home.free_title_1', 'Topluluğa')} <span className="gold-text">{tr('home.free_title_2', 'Armağanlar')}</span>
            </h2>
            <p className="text-white/60 mt-3 max-w-xl">{tr('home.free_subtitle', 'Metin2 geliştiricileri için ücretsiz sunulan modüler sistemler.')}</p>
          </div>
          <Link to="/free-products" className="btn-outline-gold inline-flex items-center gap-2 h-11 px-5 rounded-full text-xs font-extrabold tracking-widest w-fit">
            {tr('home.view_all', 'TÜMÜNÜ GÖR')} <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {list.map((s) => (
            <article key={s.id} className="group relative rounded-2xl overflow-hidden border border-white/8 bg-gradient-to-b from-[#111015] to-[#0a090c] card-hover">
              <Link to={`/free-products/${s.slug}`} className="block">
                <div className="relative aspect-[16/10] overflow-hidden bg-[#0f0e12]">
                  <img src={staticImg(s.image)} alt={s.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />
                  <div className="absolute top-4 left-4 px-3 py-1 text-[10px] font-black tracking-widest border rounded bg-emerald-500/15 border-emerald-500/40 text-emerald-300">{tr('free.badge_free', 'ÜCRETSİZ')}</div>
                </div>
                <div className="p-6">
                  <div className="text-[10px] font-bold tracking-[0.3em] text-[#e4b44e]/80 mb-2">{tr('free.card_category', 'METIN2 SİSTEMLERİ')}</div>
                  <h3 className="font-display text-lg font-bold text-white leading-snug min-h-[3rem] line-clamp-2">{s.name}</h3>
                  <p className="text-sm text-white/60 mt-2 line-clamp-2">{s.short_description}</p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="font-display text-lg font-black gold-text">{tr('free.badge_free', 'ÜCRETSİZ')}</span>
                    <span className="btn-outline-gold h-10 px-4 rounded-full text-xs font-extrabold tracking-widest inline-flex items-center gap-1.5">
                      <Download className="w-3.5 h-3.5" /> {tr('free.download', 'İNDİR')}
                    </span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
